<template>
  <div class="navbar flex jbetween">
    <div class="navbar-left flex acenter">
      <!--中粮信托有限责任公司自定义logo-->
      <img v-if="this.currentCusId === '9999003103'" src="@/assets/img/v2/navbar/logo2.png" class="logo" />
      <img v-else src="@/assets/img/v2/navbar/logo.png" class="logo" />
      <img :src="require(`@/assets/img/v2/navbar/menu-${isCollapse ? 'open' : 'collapse'}.png`)" class="size16 pointer" @click="collapseMenu"/>
    </div>

    <div class="navbar-right flex jend acenter">
      <el-dropdown class="companys" @command="handleSwitchCus" placement="bottom-start" trigger="click">
        <div class="flex acenter pointer">
          <img src="@/assets/img/v2/navbar/company.png" class="size14"/>
          <span class="font-14 ml8">{{ cusName }}</span>
        </div>
        <el-dropdown-menu slot="dropdown" class="company-item">
          <el-dropdown-item :command="item.CUSID" v-for="(item,i) in cusList" :key="`${ item.CUSID }-${item.CUSNAME}`" :class="{ active: item.CUSID == currentCusId }">{{item.CUSNAME}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <div class="divider ml20 mr20"></div>

      <div class="message flex acenter">
        <div class="flex acenter pointer" @click="msgPageVisible = !msgPageVisible">
          <img src="@/assets/img/v2/navbar/notice.png" class="size16"/>
          <span class="font-14 ml8">{{$t('frame.message')}}</span>
        </div>
        <div class="message-title" v-show="msgPageVisible">
          <div class="msg-top">
            <p>{{ $t('frame.unreadMessage') }}</p>
            <el-link type="primary" @click="toMsg">{{ $t('frame.enterTheMessageCenter') }}</el-link>
          </div>
          <div class="msg-list">
            <div v-for="(msgs,i) in msgList1" :key="i">
              <h2>{{i}}</h2>
              <div v-for="(msg,index) in msgs" :key="index" class="closePosition"
                   :class="{transClose:transClose == ''+i+index}">
                <business v-if="msg.templateId == 1" :data="msgContent(msg.content,msg,templateId)"
                          :status="msg.status">
                </business>
                <toDo v-if="msg.templateId == 2" :data="msgContent(msg.content,msg,templateId)" :status="msg.status">
                </toDo>
                <approval v-if="msg.templateId == 3" :data="msgContent(msg.content,msg,templateId)"
                          :status="msg.status">
                </approval>
                <system v-if="msg.templateId == 4" :data="msgContent(msg.content,msg,templateId)" :status="msg.status">
                </system>
                <other v-if="msg.templateId == 5" :data="msg" :status="msg.status">
                </other>
                <div class="closeBtn" @click="alreadyRead(msg.id,i,index,msg.templateId)">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-guanbi2"></use>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-dropdown>
        <div class="avatar-wrapper flex acenter ml40 pointer">
          <img class="size26" src="@/assets/img/v2/navbar/avatar-default.png">
          <span class="font-14 color-3 ml8">{{ userInfo.loginName }}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <span @click="handleUserClick">{{ $t('frame.basicInformationSettings') }}</span>
          </el-dropdown-item>
          <el-dropdown-item @click.native="changeLanguage" divided>{{lang=='En'?'English':'中文'}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <img class="size15 ml40 pointer" src="@/assets/img/v2/navbar/logout.png" @click="logout" />
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {fullscreenToggel, listenfullscreen} from "@/util/util";
import topLock from "./top-lock";
import platformMenus from "@/menus/demo/demo";
import wageMenus from "@/menus/wage/wage";
// import {getMember} from "@/api/org/member";
import store from '@/store';
import {queryUserListPage, updateBatchHrcloudMsgStatus, updateBatchMsgStatus} from "@/api/msg/msg";
import {switchCus, switchLanguage} from "@/api/user/login";
import approval from "@/template/msg/approval";
import business from "@/template/msg/business";
import system from "@/template/msg/system";
import toDo from "@/template/msg/toDo";
import other from "@/template/msg/other";
import {queryMsgList} from "@/api/msg/msg"

export default {
  components: {topLock, approval, business, system, toDo, other},
  name: "top",
  data() {
    return {
      lang: 'En',
      dialogFormMyservice: false,
      isLocal: null,
      menus: null,
      localMenu: null,
      home: true, //工作台
      search: "",
      currentUser: '',
      updateStatus: {
        ids: [],
        status: 23
      },
      msgPage: {
        limit: 50,
        page: 1,
        total: 0,
        status: 22,
        memberId: ''
      },
      msgPageVisible: false,
      msgList: [],
      msgList1: [],
      cusList: store.getters.cusList ? store.getters.cusList : [],
      currentCusId: store.getters.cusId ? store.getters.cusId : '',
      cusLogo: '',
      cusName: '',
      userInfo: store.getters.userInfo,
      timer: null,
      timer1: null,
    };
  },
  filters: {},
  created() {
    // this.$nextTick(function () {
    let newMenusArray = platformMenus.concat(wageMenus);

    this.localMenu = this.menu;
    // console.log(this.localMenu,'头部菜单');
    //this.getCurrentLoginUser();
    // })
    this.connection();
    this.queryMsg();
    this.getCusLogo();
    // console.log("cusList*************"+store.getters.cusList);
    // console.log("cusList*************"+store.getters.accessToken);
    var lang = localStorage.getItem('lang');
    if (lang) {
      this.lang = (lang === 'zh') ? 'En' : '中';
      this.$i18n.locale = lang;
    }
    //特殊处理头像
    if (this.userInfo) {
      if (this.userInfo.photoImg) {
        if (this.userInfo.photoImg.indexOf("http") == -1) {
          this.userInfo.photoImg = '';//显示本地图片
        }
      } else {
        this.userInfo.photoImg = '';//显示本地图片
      }
    }
  },
  mounted() {
    this.$nextTick(function () {
      //   this.menus = this.isLocal == 'true' ? this.localMenu : this.menu
      //   console.log("this.menus1 ")
      //   console.log(this.menus)
      // if(this.opened.length == 0){
      //   this.showCollapse()
      // }else{
      //   this.opened.push(sessionStorage.opened);
      //     this.$set(this.menus[this.opened[0] - 1],'active',true)
      //     this.$store.commit('SET_COLLAPSE','open');
      //   }
    });
    listenfullscreen(this.setScreen);
    this.isLocal = process.env.VUE_APP_LOCAL_DEVELOPMENT;
  },
  computed: {
    ...mapGetters(["isFullScren", "isCollapse", "userInfo", "menu", "opened", "memberInfo"])
  },
  methods: {
    changeLanguage() {
      // console.log(this.$i18n.locale);
      let lang = this.$i18n.locale === 'zh' ? 'en' : 'zh';
      this.$i18n.locale = lang;
      localStorage.setItem('lang', lang);
      if (lang === 'zh') {
        this.lang = 'En';
      } else {
        this.lang = '中';
      }
      // console.log(this.$route.path);
      this.$router.go(0);//刷新当前路由
    },
    //获取客户LOGO
    getCusLogo() {
      for (let i = 0; i < this.cusList.length; i++) {
        let currentCusObj = this.cusList[i];
        if (this.currentCusId == currentCusObj.CUSID) {
          this.$store.commit('SET_CUS_LOGO', currentCusObj.cusLogoUrl)
          this.cusName = currentCusObj.CUSNAME;
        }
      }
    },
    enterMsg() {
      clearTimeout(this.timer1)
      this.msgPageVisible = true
    },
    leaveMsg() {
      let self = this
      this.timer1 = setTimeout(function () {
        self.msgPageVisible = false
      }, 600)
    },
    enterMsgList() {
      clearTimeout(this.timer1)
    },
    leaveMsglist() {
      this.msgPageVisible = false
    },
    //查询消息
    queryMsg: function () {
      this.msgPage.memberId = this.userInfo.cusId + this.userInfo.userId;//拼接生成查询消息的用户ID
      queryUserListPage(this.msgPage).then(res => {
        // console.log("加载消息：=", res);
        this.msgList = res.data.records;
        this.msgPage.total = res.data.total;
        let obj = {};
        this.msgList.map((msg) => {
          let content = this.msgContent(msg.content);
          let msgBody = content.parms;
          let YM = msgBody.futureTime.substring(0, 7);
          if (this.yearMoneth != YM) {
            this.yearMoneth = YM;
            obj[this.yearMoneth] = [];
          }
          obj[this.yearMoneth].push(msg);
        });
        this.yearMoneth = "";
        this.msgList1 = obj;
        //加载人事云消息
        this.queryHroMsg();
      });

    },
    // 设置消息为已读
    alreadyRead(id, i, index, templateId) {
      if (this.timer) {
        return false;
      }
      this.updateStatus.ids.push(id);
      this.transClose = "" + i + index;
      if (templateId == 5) {
        //人事云消息
        updateBatchHrcloudMsgStatus({ids: this.updateStatus.ids, isRead: '00901'}).then(res => {
          this.timer = setTimeout(() => {
            this.timer = null;
          }, 100)
          if (res.data.code == 0) {
            let inx = this.msgList1[i].findIndex((item) => {
              return item.id == id
            })
            this.msgList1[i].splice(inx, 1);
            this.$message.success('标记已读成功');
          } else {
            this.$message.error('标记已读失败');
          }
          this.transClose = "";
        })
      } else {
        //消息服务修改已读
        updateBatchMsgStatus(this.updateStatus).then(res => {
          // console.log("修改结果", res)
          if (res.data.data) {
            let inx = this.msgList1[i].findIndex((item) => {
              return item.id == id
            })
            this.msgList1[i].splice(inx, 1);
            this.$message.success('标记已读成功');
          } else {
            this.$message.error('标记失败');
          }
        })
      }
    },
    //加载人事云消息
    queryHroMsg() {
      var that = this;
      queryMsgList({
        type: 'all',
        page: 1,
        limit: 20,
        content: '',
        status: '00900',
        isSort: true,
        total: 0
      }).then(res => {
        var data = res.data.data;
        let obj = {};
        data.records.map((msg) => {
          msg.templateId = '5';
          msg.content = msg.msgContent;
          msg.date = msg.createTime.substring(8, 10);
          msg.time = msg.createTime.substring(11, 16);
          let YM = msg.createTime.substring(0, 7);
          if (!that.msgList1.hasOwnProperty(YM)) {
            that.msgList1[YM] = [];
          }
          that.msgList1[YM].push(msg);
        });
        //对月份排降序
        const ordered = {};
        Object.keys(that.msgList1).sort().reverse().forEach(function (key) {
          //key中的数组按创建时间排降序
          that.msgList1[key].sort(that.sortArrays('createTime', false));//降序
          ordered[key] = that.msgList1[key];
        });
        that.msgList1 = ordered;
        this.yearMoneth = "";
      }).catch(() => {
      })
    },
    //对数组中的属性排序
    sortArrays(attr, rev) {
      //第二个参数没有传递 默认升序排列
      if (rev == undefined) {
        rev = 1;
      } else {
        rev = (rev) ? 1 : -1;
      }
      return (a, b) => {
        a = a[attr];
        b = b[attr];
        if (a < b) {
          return rev * -1;
        }
        if (a > b) {
          return rev * 1;
        }
        return 0;
      }
    },
    msgContent(content, templateId) {
      let arr = content.trim().split(/\s+/)
      let subString = content.slice(content.indexOf(' ') + 1)
      if (content && content != "null") {
        let obj = {}
        obj.templateId = JSON.parse(arr[0]);
        obj.content = JSON.parse(subString);
        //console.log("转化后的内容：",content);
        //let parse = JSON.parse(content);
        content.indexOf()
        let t = content.split(templateId);
        //console.log("转化后的内容：",t);
        let msgBody = JSON.parse(subString);
        msgBody.parms.date = msgBody.parms.futureTime.substring(8, 10);
        msgBody.parms.time = msgBody.parms.futureTime.substring(11, 16);
        return msgBody;
      }
    },
    //上线
    connection() {
      // console.log("1112用户信息user：",this.userInfo);
      sessionStorage.setItem("cusId", this.userInfo.cusId)
      let baseUrl = process.env.VUE_APP_BASE_URL;
      //建立连接对象
      let socket = new SockJS("/api/message/ws");
      // 获取STOMP子协议的客户端对象
      this.stompClient = Stomp.over(socket);
      //将socket对象存在session里
      // sessionStorage.setItem("stompClient", this.stompClient);
      this.stompClient.debug = null
      // 定义客户端的认证信息,按需求配置
      let headers = {
        'Authorization': 'Bearer ' + this.accessToken
      };
      // 向服务器发起websocket连接
      this.stompClient.connect(headers, () => {
        // console.log("连接websocket成功")
        this.stompClient.subscribe('/user/' + this.userInfo.userId + '/message', (msg) => {
          // msg.body存放的是服务端发送给我们的信息
          // console.log('接收消息成功', msg)
          // console.log('接收消息成功', msg.body)
          // console.log(this.$route.path)

          //把实时收到的消息放入消息提醒列表中
          let msgObj = {};
          msgObj.content = msg.body;
          msgObj.templateId = msg.body.substring(0, 1);
          ;
          msgObj.status = 22;
          this.msgList.push(msgObj);
          this.msgPage.total = this.msgPage.total + 1;
          //消息提醒quer
          let msgTitle = JSON.parse(msg.body.substring(1));
          if (this.$route.path == '/index') {
            this.$notify.info({
              title: '消息',
              message: msgTitle.subject
            });
          }
          this.resetSetItem('sockedMsgContent', msg.body);
        }, headers);
      }, (err) => {
        // 连接发生错误时的处理函数
        console.log('失败')
        console.log(err);
      });
    },
    // openMenu(id,index){
    //   this.$store.commit('SET_COLLAPSE','open');
    //   let opened = [];
    //   opened.push(id)
    //   this.$store.commit('SET_OPENED',opened);
    //   sessionStorage.setItem('opened',opened);
    //   //没有子菜单的一级菜单单独处理，直接跳转
    //   console.log(this.menus[id-1].hasOwnProperty('children'))
    //   if(!this.menus[id-1].hasOwnProperty('children')){
    //     this.$router.push({ path:this.menus[id-1].path });
    //   }
    //
    //   this.home = false;
    //   for(var i = 0;i < this.menus.length;i++){
    //     if(i == index){
    //       this.$set(this.menus[i],'active',true)
    //     }else{
    //       this.$set(this.menus[i],'active',false)
    //     }
    //   }
    // },
    // getCurrentLoginUser(){
    //     let memberId = this.memberInfo.id;
    //     console.log("this.memberInfo.id==",memberId);
    //     //根据成员ID查询成员信息
    //     getMember(memberId).then(res =>{
    //       console.log("查询出成员的信息：3333333333333333：",res);
    //       this.$store.commit("SET_MEMBER_INFO",res.data.data);
    //       this.currentUser = res.data.data.name;
    //     })
    // },
    showCollapse() {
      this.$store.commit("SET_COLLAPSE");
      // this.home = true;
      // for(var i = 0;i < this.menus.length;i++){
      //     this.$set(this.menus[i],'active',false)
      // }
      // this.$store.commit('SET_COLLAPSE','close');
      // this.$router.push({ path: '/index' });
      // this.$store.commit('SET_OPENED',0);
      // sessionStorage.setItem('opened',0);
    },
    handleScreen() {
      fullscreenToggel();
    },
    huanfu() {
      if (localStorage.getItem("Theme") == "light-theme") {
        localStorage.setItem('Theme', "dark-theme");
        localStorage.setItem('Color', "#ffffff");
        this.$store.commit('CHANGECOLOR')
        document.getElementsByTagName("body")[0].className = localStorage.getItem("Theme");

      } else {
        localStorage.setItem('Theme', "light-theme");
        localStorage.setItem('Color', "#000000");
        this.$store.commit('CHANGECOLOR')
        document.getElementsByTagName("body")[0].className = localStorage.getItem("Theme");
      }
    },
    setScreen() {
      this.$store.commit("SET_FULLSCREN");
    },
    logout() {
      this.$confirm(this.$t('frame.logoutTipContent'), this.$t('frame.logoutTipTitle'), {
        confirmButtonText: this.$t('determine'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then(() => {
        this.$store.dispatch("LogOut").then(() => {
          this.$router.push({path: "/login"});
        });
        this.$store.commit("SET_OPENED", []);
        this.showCollapse();
        sessionStorage.setItem("opened", []);
        this.$router.push({path: "/login"});
      });
    },
    /**
     * 处理设置的点击事件
     * @param item
     */
    handleSettingClick(item) {
      if (item.path) {
        if (item.path === this.$route.path) {
          this.reload();
        } else {
          let path = item.path;
          let params = "";
          // 处理路由URL带参数的菜单
          if (typeof item.params === "function") {
            params = item.params(this.$store);
            if (item.path && item.path.indexOf("/:") !== -1) {
              const pathItemArr = item.path.split("/");
              pathItemArr.forEach((pathItem) => {
                if (pathItem.indexOf(":") === 0) {
                  const paramName = pathItem.substring(1);
                  path = path.replace(pathItem, params[paramName]);
                }
              });
            }
          }
          this.$router.push({
            path: path,
            query: item.query
          });
        }
      } else {
        item.handle(this);
      }
    },
    /**
     * 处理用户信息的点击事件
     * @param item
     */
    handleUserClick() {
      // this.$router.push("/person/edit");
      this.$router.push("/account/getAccountInfo.action");
    },
    toMsg() {
      this.$router.push("/sys/msgTabs");
    },
    //切换客户
    handleSwitchCus(command) {
      if (this.currentCusId === command) {
        return;
      }
      //切换客户
      this.currentCusId = command;
      let cusId = "";
      let branchId = "";
      let cusName = "";
      for (let i = 0; i < this.cusList.length; i++) {
        let currentCusObj = this.cusList[i];
        if (this.currentCusId == currentCusObj.CUSID) {
          cusId = currentCusObj.CUSID;
          branchId = currentCusObj.BRANCHID;
          cusName = currentCusObj.CUSNAME;
          this.$store.commit('SET_CUS_LOGO', currentCusObj.cusLogoUrl)
          // this.cusLogo = currentCusObj.cusLogoUrl;
          this.cusName = currentCusObj.CUSNAME;
          break;
        }
      }
      //切换客户
      var that = this;
      switchCus({cusId: cusId, branchId: branchId, cusName: cusName}).then(res => {
        let resData = res.data.data;
        if (res.data.statusCode == 200) {
          if (res.data.success) {
            this.$message.success(res.data.msg);
            this.$store.commit('SET_ACCESS_TOKEN', resData.access_token);
            this.$store.commit('SET_REFRESH_TOKEN', resData.refresh_token);
            this.$store.commit('SET_CUS_ID', resData.cusId);
            this.$store.commit('SET_USER_INFO', resData);
            this.$store.commit('SET_BRANCH_INFO', {id: resData.branchId});
            this.$store.commit('SET_PMS', resData.pms);
            this.$store.commit('SET_AUTHORIZED_AGENCIES', resData.authorizedAgencies);
            this.$store.commit('SET_CUS_LIST', resData.cusList);
            this.$store.commit('CLEAR_LOCK');
            this.$store.dispatch('getCusListTotal');
            setTimeout(function () {
              that.$router.go(0);// 刷新当前路由
            }, 1000);
          } else {
            this.$message.error(res.data.msg);
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    collapseMenu() {
      this.$store.commit("SET_COLLAPSE")
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 48px;
  background-color: #FFFFFF;
  border-bottom: 1px solid #E8E8E8;
  padding: 0 18px;

  .logo {
    width: 105px;
    margin-right: 57px;
  }

  .avatar-wrapper {
    .el-icon-caret-bottom {
      color: #D1D1D6;
      margin-left: 8px;
    }
  }

  .divider {
    width: 1px;
    height: 17px;
    opacity: 0.2;
    background-color: #1C1C1C;
  }
}
.collapse {
  opacity: 0.5;
}

.userbox {
  display: flex;
  align-items: center;
}

.el-dropdown {
  margin-right: 10px;
  margin-left: 10px;
}

.el-tooltip {
  margin-right: 10px;
}

span + .xiala {
  margin-left: 0;
  font-size: 12px;
  transform: rotate(180deg);
  margin-left: 8px;
  color: #333333 !important;
}

.pifu {
  width: 30px;
  height: 30px;
  box-sizing: border-box;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: #036EB8;
  border: none;
}

.pifu .icon, .pifu .el-icon-office-building {
  font-size: 20px;
  margin: 0;
  color: #c1c1c1;
}

.super-navs {
  padding-left: 80px;
  display: flex;
  cursor: pointer;
}

.super-nav:hover {
  background: #299cfe;
  color: #ffffff;
}

.super-nav.is-active {
  background: #008aff;
  color: #ffffff;
}

.super-nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #008aff;
  padding: 7px 15px;
}

.super-nav p {
  font-size: 12px;
  line-height: 12px;
  margin-top: 8px;
}

.super-nav .icon {
  margin: 0;
}

.top {
  padding-left: 0;
}

.top-item {
  margin: 0;
}

.icon {
  font-size: 20px;
  margin-top: 2px;
  margin-right: 6px;
  color: #000;
}

.quanping .icon {
  font-size: 18px !important;
}

.setting {
  margin-left: 10px;
}

.setting .icon {
  font-size: 20px;
  margin-right: 0;
}

.user-logo {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-top: 2px;
  margin-right: 6px
}

.index .top {
  /*border-bottom: 1px solid #98C8FC;*/
}

.tags-breadcrumb {
  padding-left: 0;
}

.message {
  position: relative;
}

.message .messageBox {
  // display: none;
  position: absolute;
  max-height: 300px;
  top: 65px;
  right: 0;
  z-index: 99;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14);
}

.message .message-title {
  width: 350px;
  height: 90vh;
  background: #eee;
  position: absolute;
  top: 62px;
  left: -110px;
  z-index: 999;
  box-shadow: -3px 0 8px #ccc;
}

.message .message-title .msC1 {
  width: 134px;
  float: left;
  margin-top: 24px;
  color: #999;
  font-size: 16px;
}

.message .message-title .msC2 {
  width: 102px;
  float: left;
  color: #3f85ff;
  font-size: 12px;
  border: 1px solid #3f85ff;
  height: 20px;
  text-align: center;
  line-height: 20px;
  border-radius: 20px;
  margin-top: 20px;
  cursor: pointer;
}

.el-radio {
  color: #999;

}

.message .message-title .msC1 {
  width: 134px;
  float: left;
  margin-top: 24px;
  color: #999;
  font-size: 16px;
}

.message .message-title .msC2 {
  width: 102px;
  float: left;
  color: #3f85ff;
  font-size: 12px;
  border: 1px solid #3f85ff;
  height: 20px;
  text-align: center;
  line-height: 20px;
  border-radius: 20px;
  margin-top: 20px;
  cursor: pointer;
}

.msg-list {
  display: block;
  height: calc(100% - 40px);
  overflow-y: auto;
  border-radius: 8px;
  padding: 0 9px;
  background: #f3f3f3;

  h2 {
    font-size: 16px;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 22px;
    padding: 5px 0;
  }

  li {
    padding: 20px 14px;
    display: block;
    border-bottom: 1px solid #eee;

    .t1 {
      color: #8cb2f4;
      font-size: 12px;
      margin-right: 5px;
      margin-bottom: 8px;
      display: inline-block;
    }

    .t2 {
      color: #aaa;
      font-size: 10px;
    }

    .msg-content {
      width: 213px;
      color: #000;
      font-size: 12px;
      white-space: pre-wrap;
      line-height: 18px;
      position: relative;

      i {
        position: absolute;
        width: 4px;
        height: 4px;
        border-radius: 50%;
        background: #000;
        top: 5px;
        left: -8px;
      }
    }
  }
}

.closePosition {
  position: relative;
}

.closeBtn {
  position: absolute;
  right: -6px;
  top: -3px;
  cursor: pointer;
  font-size: 20px;
}

.transClose {
  animation: myfirst 0.25s;
  -moz-animation: myfirst 0.25s; /* Firefox */
  -webkit-animation: myfirst 0.25s; /* Safari 和 Chrome */
  -o-animation: myfirst 0.25s; /* Opera */
}

.msg-top {
  display: flex;
  height: 33px;
  padding-left: 7px;
  padding-right: 14px;
  justify-content: space-between;
  align-items: center;
  background: #fff;
}

.msg-top p {
  font-size: 13px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 18px;
}

.msg-top .el-link {
  font-size: 10px;
  font-weight: 400;
  color: rgba(51, 133, 255, 1);
  line-height: 14px;
}

.ciic-cursor-pointer1 > span {
  color: #333;
  padding-right: 4px;
  padding-left: 25px;
}

.ciic-cursor-pointer1 > .icon {
  color: #999;
}

@keyframes myfirst {
  from {
    transform-origin: center center;
  }
  to {
    transform: scale(0.01)
  }
}

@-moz-keyframes myfirst /* Firefox */
{
  from {
    transform-origin: center center;
  }
  to {
    transform: scale(0.01)
  }
}

@-webkit-keyframes myfirst /* Safari 和 Chrome */
{
  from {
    transform-origin: center center;
  }
  to {
    transform: scale(0.01)
  }
}

@-o-keyframes myfirst /* Opera */
{
  from {
    transform-origin: center center;
  }
  to {
    transform: scale(0.01)
  }
}

.dark-theme .logo_w, .light-theme .logo_b {
  display: none;
}

.light-theme .logo_w, .dark-theme .logo_b {
  display: flex;
}
  .company-item {
    padding: 30px 20px 10px 20px;
    border-color: #ebebeb;
    -webkit-border-radius: 18px;
    -moz-border-radius: 18px;
    border-radius: 18px;
    max-height: 400px;
    overflow-y: auto;
    .el-dropdown-menu__item {
      width: 280px;
      height: 40px;
      line-height: 40px;
      -webkit-border-radius: 20px;
      -moz-border-radius: 20px;
      border-radius: 20px;
      background-color: #f2f2f2;
      margin-bottom: 20px;
      border: 1px dashed #e1e1e1;
      text-align: center;
      &:last-child {
        margin-bottom: 0;
      }
      &.active, &:hover {
        background-color: #FF9601;
        color: #fff;
        border-color: #FF9601;
      }
    }
  }
</style>

